import React from 'react';

const get_style = ({ query, items }) => {
    if (!items || !items.length) {
        return null;
    }

    const styles = items.map(({ uuid, color }) => {
        return `

            td.seatmap-seat[${query}="${uuid}"]:not(.locked_for_social_distancing) svg path {
                fill: ${color};
            }

            td.seatmap-seat.locked_for_social_distancing[${query}="${uuid}"] svg path {
                stroke: ${color};
                fill: #fff;
            }
        `;
    });

    return <style>{styles.join('\n')}</style>;
};

export function SeatStyles({ items, query }) {
    if (!items?.length) {
        return null;
    }

    return get_style({ items, query });
}
